import { date } from 'yup';
import moment from 'moment';
import i18n from 'src/utils/i18n/i18n';

const validate = (values, requireValue) => {
  return requireValue.reduce((sum, x) => {
    return (!values[x] || values[x].length === 0) ? { ...sum, [x]: i18n.t('REQUIRED') } : sum;
  }, {});
};

export const dateFormat = format =>
  date().transform((_value, originalValue) => {
    const value = moment(originalValue, format, true);
    return value.isValid() ? value.toDate() : new Date('');
  });

export const defaultFormSubmit = (values, form, requireValues) => {
  if (requireValues) {
    const errors = validate(values, requireValues);
    if (Object.keys(errors).length > 0) {
      form.setErrors(errors);
      form.setSubmitting(false);
      return;
    }
  }

  const {
    props: { onSubmit },
  } = form;
  if (onSubmit) onSubmit({ values, form });
};
